export const MAX_BREADCRUMBS = 100;
